import React from 'react'
import Entity from '../Entity';

class Follow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      entity: props.story.entity,
      payload: props.story.payload,
    }
  }

  render() {
    const followingMsg = I18n.t('jslibrary.new_follower');
    return (
        <div className="afd-story__content">
          <Entity entity={this.state.entity}/> {followingMsg}
        </div>
    )
  }
}
export default Follow;